// extracted by mini-css-extract-plugin
module.exports = {"appStoreLinks":"StoreLinks_appStoreLinks__rTrY0","rating":"StoreLinks_rating__KbXmB"};